import get from 'lodash/get';
import SvgAssets from '@adsk/bim360-matrix-react-assets';

const getFileType = (fileType, extensions) =>
  extensions.reduce((mapping, extension) => {
    mapping[extension] = fileType;
    return mapping;
  }, {});

/* eslint-disable */
// prettier-ignore
export const FILE_TYPE_MAPPING = {
  '3ds': '3ds',
  dotx: 'dotx',
  dwg: 'dwg',
  dwf: 'dwf',
  dwfx: 'dwfx',
  f3d: 'f3d',
  idw: 'idw',
  ifc: 'ifc',
  iwm: 'iwm',
  mat: 'mat',
  max: 'max',
  maxc: 'maxc',
  mcr: 'mcr',
  ms: 'ms',
  mxp: 'mxp',
  nwd: 'nwd',
  nwc: 'nwc',
  obj: 'obj',
  pdf: 'pdf',
  potx: 'potx',
  ppsx: 'ppsx',
  ppt: 'ppt',
  rvt: 'rvt',
  odp: 'odp',
  ods: 'ods',
  odt: 'odt',
  vssx: 'vssx',
  xls: 'xls',
  xlsm: 'xlsm',
  xltx: 'xltx',
  ...getFileType('archive', [
    'cab', '7z', 'aac', 'ace', 'alz', 'apk', 'at3', 'bke', 'arc', 'arj', 'ass', 'sas', 'b', 'ba',
    'big', 'bik', 'bin', 'bkf', 'bzip2', 'bld', 'c4', 'cals', 'clipflair', 'clipflair', 'cpt', 'sea',
    'daa', 'deb', 'dmg', 'ddz', 'dpe', 'egg', 'egt', 'ecab', 'ezip', 'ess', 'gho', 'ghs', 'gzip', 'gz',
    'ipg', 'jar', 'lbr', 'lawrence', 'lbr', 'lqr', 'lha', 'lzh', 'lzip', 'lz', 'lzo', 'lzma', 'lzx', 'mbw',
    'mpq', 'bin', 'nth', 'osz', 'pak', 'par', 'par2', 'paf', 'pyk', 'pk3', 'pk4', 'rar', 'rag', 'rpm', 'sen',
    'sit', 'sitx', 'skb', 'tar', 'tgz', 'tb', 'tib', 'uha', 'uue', 'viv', 'vol', 'vsa', 'wax', 'z', 'zoo', 'zip'
  ]),
  ...getFileType('audio', ['aif', 'aifc', 'aiff', 'bwf', 'wav', 'la', 'pac', 'wv', 'wma', 'mp2', 'mp3', 'm4a', 'mp4', 'm4p', 'aac']),
  ...getFileType('docx', ['doc', 'docm', 'docx', 'dot', 'dotm', 'rtf']),
  ...getFileType('image', [
    'ase', 'art', 'blp', 'bmp', 'cd5', 'cit', 'cpt', 'cr2', 'cut', 'dds', 'dib', 'djvu', 'egt', 'exif', 'gif', 'gpl', 'grf',
    'icns', 'ico', 'iff', 'ilbm', 'lbm', 'jng', 'jpg', 'jpeg', 'jp2', 'jps', 'lbm', 'max', 'miff', 'mng', 'msp', 'nitf',
    'otb', 'pbm', 'pc1', 'pc2', 'pc3', 'pcf', 'pcx', 'pdn', 'pgm', 'pi1', 'pi2', 'pi3', 'pict', 'png', 'pnm', 'pns', 'ppm',
    'psb', 'psd', 'pdd', 'psp', 'px', 'pxm', 'pxr', 'qfx', 'raw', 'rle', 'sct', 'sgi', 'rgb', 'int', 'bw ', 'tga', 'targa',
    'icb', 'vda', 'vst', 'pix', 'tif', 'tiff', 'vtf', 'xbm', 'xcf', 'xpm'
  ]),
  ...getFileType('pptx', ['pot', 'potm', 'pps', 'ppsm', 'ppt', 'pptm', 'pptx']),
  ...getFileType('textfile', [
    '602', 'abw', 'acl', 'afp', 'ami', 'ans', 'asc', 'aww', 'ccf', 'cwk', 'dbk',
    'egt', 'epub', 'ezw', 'fdx', 'ftm', 'ftx', 'gdoc', 'html', 'hwp', 'hwpml', 'log', 'lwp',
    'mbp', 'md', 'mcw', 'mobi', 'nb', 'nbp', 'odm', 'ott', 'omm', 'pages', 'pap', 'pdax',
    'quox', 'rpt', 'sdw', 'se', 'stw', 'sxw', 'tex', 'info', 'troff', 'txt', 'uof', 'uoml', 'via', 'wpd',
    'wps', 'wpt', 'wrd', 'wrf', 'wri', 'xhtml', 'xml', 'xps'
  ]),
  ...getFileType('video', ['aaf', 'avi', '3gp', 'gif', 'avi', 'flv', 'mpeg', 'mpg', 'mpe', 'ogg', 'swf', 'wmv', 'wtv']),
  ...getFileType('vsdx', ['vsd', 'vsdm', 'vsdx']),
  ...getFileType('xlsx', ['csv', 'xlsb', 'xlsx'])
};
/* eslint-enable */
const ENTITY_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  PROCESSING: 'PROCESSING',
  PROCESSING_ABORTED: 'PROCESSING_ABORTED',
  PROCESSING_COMPLETE: 'PROCESSING_COMPLETE',
  PROCESSING_SUSPEND: 'PROCESSING_SUSPEND'
};

const FILE_MIME_TYPE = {
  FDX: 'application/vnd.autodesk.fdx'
};

const getEntityField = (entity, key) =>
  get(entity, `version.${key}`) || get(entity, `currentVersion.${key}`) || get(entity, key);

const getFileExtension = filename => {
  if (!filename || filename.indexOf('.') === -1) {
    return '';
  }

  const extension = filename.split('.').pop();
  return extension.toLowerCase();
};

const isProcessing = entity => {
  const moveState = getEntityField(entity, 'moveState');

  // DOS move workflow will add a storm:move-state to lineage
  if (moveState) {
    if (moveState === ENTITY_STATUS.PROCESSING) {
      return true;
    }
    if (moveState !== ENTITY_STATUS.SUCCESS) {
      return false;
    }
  }

  const processState = getEntityField(entity, 'processState');
  if (
    !processState ||
    [
      ENTITY_STATUS.PROCESSING_COMPLETE,
      ENTITY_STATUS.PROCESSING_ABORTED,
      ENTITY_STATUS.PROCESSING_SUSPEND
    ].includes(processState)
  ) {
    return false;
  }

  // Which means: no process state, PROCESSING_ABORTING, EXTRACTION_PENDING, PROCESSING, PROCESSING_COPYING
  // are all belongs to processing status.
  return true;
};

const isProcessFailure = entity => {
  const moveState = getEntityField(entity, 'moveState');

  // DOS move workflow will add a storm:move-state to lineage
  if (moveState) {
    if (![ENTITY_STATUS.PROCESSING, ENTITY_STATUS.SUCCESS].includes(moveState)) {
      return true;
    }
  }

  const extractState = getEntityField(entity, 'extractionState');
  const processState = getEntityField(entity, 'processState');
  const partialFailure = getEntityField(entity, 'partialExtractionFailure');

  return (
    [ENTITY_STATUS.PROCESSING_COMPLETE, ENTITY_STATUS.PROCESSING_ABORTED].includes(processState) &&
    extractState === ENTITY_STATUS.FAILED &&
    partialFailure !== true
  );
};

const isSuspend = entity => {
  const processState = getEntityField(entity, 'processState');
  return ENTITY_STATUS.PROCESSING_SUSPEND === processState;
};

const isPdf = (entity = {}) => {
  if (entity.fileName) {
    return getFileExtension(entity.fileName) === 'pdf';
  }
  return false;
};

const isFdx = entity =>
  getEntityField(entity, 'mimeType') === FILE_MIME_TYPE.FDX ||
  getEntityField(entity, 'mime_type') === FILE_MIME_TYPE.FDX;

export const getIconName = (entity = {}) => {
  let docType;

  if (isProcessing(entity)) {
    return `doctype-processing`;
  }

  if (isProcessFailure(entity)) {
    return `doctype-extract-failure`;
  }

  if (isSuspend(entity)) {
    return isPdf(entity) ? `doctype-pdf-native` : `doctype-process-suspend`;
  }

  const extensionKey = FILE_TYPE_MAPPING[getFileExtension(entity.fileName || entity.name)];
  if (extensionKey) {
    docType = extensionKey;
  } else if (isFdx(entity)) {
    docType = 'exchange';
  } else if (entity.isDocument) {
    docType = 'sheet';
  } else {
    docType = 'file';
  }

  return `doctype-${docType}`;
};

export const getIcon = entity => SvgAssets[getIconName(entity)];
